import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['street', 'zipCode', 'city', 'country']

  connect() {
    this.waitForGoogleMaps()
  }

  disconnect() {
    if (this.pollIntervalId) {
      clearInterval(this.pollIntervalId)
      this.pollIntervalId = null
    }
    if (this.autocomplete && window.google?.maps?.event) {
      window.google.maps.event.clearInstanceListeners(this.autocomplete)
      this.autocomplete = null
    }
  }

  waitForGoogleMaps() {
    if (window.google?.maps?.places) {
      this.initAutocomplete()
      return
    }
    this.pollIntervalId = setInterval(() => {
      if (window.google?.maps?.places) {
        clearInterval(this.pollIntervalId)
        this.pollIntervalId = null
        this.initAutocomplete()
      }
    }, 200)
  }

  initAutocomplete() {
    this.autocomplete = new window.google.maps.places.Autocomplete(this.streetTarget, {
      types: ['address'],
      fields: ['address_components']
    })

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace()
      if (!place || !place.address_components) return

      const parts = this.parseAddress(place.address_components)
      this.streetTarget.value = [parts.streetNumber, parts.route].filter(Boolean).join(' ')

      if (this.hasZipCodeTarget) {
        this.zipCodeTarget.value = parts.postalCode || ''
      }
      if (this.hasCityTarget) {
        this.cityTarget.value = parts.city || ''
      }
      if (this.hasCountryTarget) {
        this.countryTarget.value = parts.country || ''
      }
    })
  }

  parseAddress(components) {
    const parts = {}
    components.forEach((component) => {
      const types = component.types
      if (types.includes('street_number')) {
        parts.streetNumber = component.long_name
      } else if (types.includes('route')) {
        parts.route = component.long_name
      } else if (types.includes('postal_code')) {
        parts.postalCode = component.long_name
      } else if (types.includes('locality')) {
        parts.city = component.long_name
      } else if (!parts.city && types.includes('postal_town')) {
        parts.city = component.long_name
      } else if (types.includes('country')) {
        parts.country = component.short_name
      }
    })
    return parts
  }
}
